import ds from './DataSourceService'

const baseUrl = '/pois'

// const getAllPois = () => {
//   return ds.apiClientThinkHome.get(baseUrl)
// }

const getPoiById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}
const getPoisByClientAppId = clientAppId => {
  return ds.apiClientThinkHome.get(baseUrl + '?clientAppId=' + clientAppId)
}

// const getPoisByPoiTypeId = poiTypeId => {
//   return ds.apiClientThinkHome.get(baseUrl + '?poiTypeId=' + poiTypeId)
// }

const createPoi = poi => {
  return ds.apiClientThinkHome.post(baseUrl, poi)
}

const updatePoi = poi => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + poi.id, poi)
}

const deletePoi = poiId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + poiId)
}

const getPoiTypesForParentType = parentType => {
  return ds.apiClientThinkHome.get(baseUrl + '/types?parentType=' + parentType)
}

const getAllPoiTypes = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/types')
}

// MEDIA
const getMediaForPoi = (id, params) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/media-content', {
    params
  })
}

const getPoiTitleImage = (id, params) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/title-image', {
    params
  })
}

const createMediaForPoi = (id, media) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + id + '/media-content',
    media
  )
}
const updateMediaForPoi = (id, media) => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + id + '/media-content',
    media
  )
}
const deleteMediaForPoi = (id, mediaId) => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + id + '/media-content', {
    data: { mediaId: mediaId }
  })
}
const linkPoiWithMedia = (poiId, mediaIds) => {
  return ds.apiClientThinkHome.post(baseUrl + '/' + poiId + '/link-media', {
    mediaIds: mediaIds
  })
}

const getPoiGalleries = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/galleries')
}

const getPoisParent = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/parent')
}

const setTitleImage = (id, mediaId) => {
  return ds.apiClientThinkHome.post(
    baseUrl + `/${id}/media-content/${mediaId}/set-title-image`,
    {}
  )
}

const saveGallerySortOrders = (id, items) => {
  return ds.apiClientThinkHome.patch(
    baseUrl + `/${id}/media-content/sort-orders`,
    { items }
  )
}

const checkCrossSectionFloorAvailability = (id, floor, excludeMediaId) => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + id + '/media-content/floor-check',
    {
      params: { floor, excludeMediaId }
    }
  )
}

export default {
  getMediaForPoi,
  createPoi,
  updatePoi,
  deletePoi,
  getPoiById,
  getPoiGalleries,
  getPoiTypesForParentType,
  linkPoiWithMedia,
  getPoisByClientAppId,
  getPoisParent,
  getAllPoiTypes,
  createMediaForPoi,
  updateMediaForPoi,
  deleteMediaForPoi,
  setTitleImage,
  getPoiTitleImage,
  saveGallerySortOrders,
  checkCrossSectionFloorAvailability
}
